import { Check } from 'lucide-react';
import { useTournamentDetail } from 'modules/jogador/tournaments/useTournamentDetail';
import { CategoryOption } from 'modules/jogador/tournaments/components/CategoryOption';
import { DuoPartnerCard } from 'modules/jogador/tournaments/components/DuoPartnerCard';
import { Button } from 'shared/components/ui/Button';
import { NotFoundPage } from 'shared/pages/NotFoundPage';
import { TournamentDetailSkeleton } from 'modules/jogador/tournaments/components/TournamentSkeletons';
import { formatBRL } from 'shared/utils/format';

export function TournamentDetailPage() {
  const { tournament, isLoading, selectedCategoryId, setSelectedCategoryId, paymentChoice, setPaymentChoice } =
    useTournamentDetail();

  if (isLoading) return <TournamentDetailSkeleton />;
  if (!tournament) return <NotFoundPage />;

  return (
    <section className="mx-auto max-w-2xl pb-28">
      <div className="border-b border-border/60 bg-surface px-4 py-8">
        <p className="text-xs font-semibold uppercase tracking-wide text-primary">
          Torneio · {tournament.sport}
        </p>
        <h1 className="mt-1 font-heading text-2xl font-bold text-ink">{tournament.name}</h1>
        <p className="mt-1 text-sm text-ink-secondary">
          {tournament.dateLabel} · {tournament.arenaName}
        </p>
      </div>

      <div className="px-4 py-6">
        <div className="grid grid-cols-2 gap-3">
          <div className="rounded-xl border border-border/70 p-4">
            <p className="text-xs text-ink-secondary">Inscrição</p>
            <p className="font-semibold text-ink">{tournament.entryFeeLabel}</p>
          </div>
          <div className="rounded-xl border border-border/70 p-4">
            <p className="text-xs text-ink-secondary">Cancelável até</p>
            <p className="font-semibold text-ink">{tournament.cancelableUntilLabel}</p>
          </div>
        </div>

        <h2 className="mt-6 text-sm font-semibold uppercase tracking-wide text-ink-secondary">
          Categorias
        </h2>
        <div className="mt-3 flex flex-col gap-2">
          {tournament.categories.map((category) => (
            <CategoryOption
              key={category.id}
              category={category}
              isSelected={category.id === selectedCategoryId}
              onSelect={setSelectedCategoryId}
            />
          ))}
        </div>

        <div className="mt-6">
          <DuoPartnerCard partner={tournament.duoPartner} />
        </div>
      </div>

      <div className="fixed inset-x-0 bottom-16 border-t border-border bg-surface px-4 py-4 shadow-card">
        <div className="mx-auto flex max-w-2xl gap-3">
          <Button
            variant="ghost"
            className="flex-1"
            onClick={() => setPaymentChoice('integral')}
            disabled={paymentChoice !== null}
          >
            Pagar tudo
          </Button>
          <Button
            className="flex-1"
            onClick={() => setPaymentChoice('dividido')}
            disabled={paymentChoice !== null}
          >
            {paymentChoice ? (
              <>
                <Check className="h-4 w-4" strokeWidth={2.5} aria-hidden="true" />
                Inscrição confirmada
              </>
            ) : (
              `Dividir 50/50 · ${formatBRL(tournament.quotaAmount)}`
            )}
          </Button>
        </div>
      </div>
    </section>
  );
}
